import { request } from "../../api";
import { unwrapList } from "../devices";

export interface URLGroupRow {
  id: string;
  name: string;
  description: string;
  is_default: boolean;
  is_active: boolean;
  members_count: number;
  rule_usage_count: number;
  created_at: string;
  updated_at: string;
}

export interface URLGroupMemberRow {
  id: string;
  url_pool: string;
  url_pool_kind: string;
  url_pool_value: string;
  vuln_status: string;
  created_at: string;
}

interface Paginated<T> {
  count?: number;
  next?: string | null;
  previous?: string | null;
  results?: T[];
}

export const urlGroupsApi = {
  list: async () => {
    const data = await request<Paginated<URLGroupRow> | URLGroupRow[]>(
      `/api/admin/v1/url-groups/`,
    );
    return unwrapList(data);
  },
  create: (input: { name: string; description?: string; is_active?: boolean }) =>
    request<URLGroupRow>(`/api/admin/v1/url-groups/`, { method: "POST", json: input }),
  patch: (
    id: string,
    body: Partial<{ name: string; description: string; is_active: boolean }>,
  ) =>
    request<URLGroupRow>(`/api/admin/v1/url-groups/${id}/`, {
      method: "PATCH",
      json: body,
    }),
  delete: (id: string) =>
    request<undefined>(`/api/admin/v1/url-groups/${id}/`, { method: "DELETE" }),
  listMembers: (id: string) =>
    request<URLGroupMemberRow[]>(`/api/admin/v1/url-groups/${id}/members/`),
  addMember: (id: string, body: { url_pool: string }) =>
    request<URLGroupMemberRow>(`/api/admin/v1/url-groups/${id}/members/`, {
      method: "POST",
      json: body,
    }),
  removeMember: (id: string, memberId: string) =>
    request<undefined>(
      `/api/admin/v1/url-groups/${id}/members/${memberId}/`,
      { method: "DELETE" },
    ),
};
